import { Mappable } from './mappable';

export class CanadianProvince extends Mappable {
  code: string;
  name: string;

  constructor() { super() }
}